<template>
  <div class="container">
    <NavBar :year="year" />
    <section class="thumbnails">
      <div class="container">
        <div class="card">
          <header class="card-header is-align-items-center">
            <p class="card-header-title">
              Project Thumbnails
            </p>
            <span class="is-block content is-size-7 has-text-grey">
              (Images are generated from student's
              <i>presentation.png</i> file)
            </span>
          </header>
          <div class="card-content">
            <div class="box" v-if="loading">Loading...</div>
            <template v-else>
              <ThumbnailGroup
                :lab="lab"
                :key="lab_idx"
                v-for="(lab, lab_idx) in labs.items"
              />
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ThumbnailGroup from "@/components/thumbs/ThumbnailGroup.vue";
import NavBar from "@/components/NavBar.vue";
export default {
  data() {
    return {
      loading: false,
      hasError: false,
      error: null,
      year: ""
    };
  },
  components: {
    ThumbnailGroup,
    NavBar
  },
  methods: {
    ...mapActions(["loadLabs"])
  },
  mounted() {
    if (this.$route.params.year) {
      this.year = this.$route.params.year;
    } else {
      this.year = this.defaultYear;
    }
    this.hasError = false;
    this.loading = true;
    const handleError = () => {
      this.loading = false;
      this.hasError = true;
      this.error = "Session load error, please reload";
    };
    this.loadLabs(this.year)
      .then(() => {
        this.loading = false;
      })
      .catch(handleError);
  },
  computed: {
    ...mapGetters(["labs", "defaultYear"])
  }
};
</script>
<style scoped>
.card {
  border-top: 1px solid #dedede;
}
.card-header {
  align-items: center;
}
.card-header-title {
  font-size: 12px;
  text-transform: uppercase;
}
.card-header > span {
  padding: 0.75rem;
}
.lab-col .box {
  width: 100%;
  height: 100%;
  text-align: center;
  /* min-height: 200px; */
  font-size: 16px;
  font-family: Helvetica;
  font-weight: bold;
  background-color: #feffdd;
  border-radius: 0px;
}
.student-col {
}
.bg_0 {
  background-color: #55efc4;
}
.bg_1 {
  background-color: #74b9ff;
}
.bg_2 {
  background-color: #ff7675;
}
.bg_3 {
  background-color: #d63031;
}
.bg_4 {
  background-color: #e17055;
}
.bg_5 {
  background_color: #fdcb6e;
}
</style>
